<template>
  <client-only>
    <el-dialog title="" :visible.sync="showLogin" width="900px" :before-close="handleClose" :lock-scroll="false" :show-close="false">
      <div class="login-page">
        <img class="login-img" src="~@/assets/images/login-top-img.png" alt="">
        <img class="login-bg" src="~@/assets/images/login-bg.png" alt="">
        <div class="login-form">
          <img class="login-logo" src="~@/assets/images/login-logo.png" alt="">
          <el-form ref="loginForm"  :model="form"  :rules="rules"  @submit.native.prevent="handleLogin">
            <el-form-item prop="username" label="账号">
              <el-input v-model="form.username" placeholder="请输入用户名" prefix-icon="el-icon-user" size="large" ></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码">
              <el-input v-model="form.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" size="large" show-password></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="form.remember">记住密码</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button  type="primary"  @click="handleLogin"  size="large" :loading="loading" class="login-btn">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </client-only>
</template>

<script>
export default {
  middleware({ store, redirect }) {
    // 如果已经登录，跳转到首页
    if (store.state.token) {
      return redirect('/')
    }
  },
  
  data() {
    return {
      form: {
        username: '',
        password: '',
        remember: true
      },
      loading: false,
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { message: '请输入正确的用户名格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 0, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    showLogin() {
      return this.$store.state.showLogin
    }
  },
  methods: {
    async handleLogin() {
      try {
        this.loading = true
        if (!this.form.username) {
          this.$message.warning('请输入正确的用户名')
          this.loading = false
          return false
        }
        if (!this.form.password) {
          this.$message.warning('请输入密码')
          this.loading = false
          return false
        }
        // 验证表单
        const valid = await this.$refs.loginForm.validate()
        if (!valid) return
        // 调用登录操作
        const result = await this.$store.dispatch('login', {
          username: this.form.username,
          password: this.form.password,
          remember: this.form.remember
        })
        if (result.success) {
          this.$message.success('登录成功！')
          this.$store.commit('setShowLogin', false)
        } else {
          this.$message.error(result.message || '登录失败')
        }
      } catch (error) {
        this.$message.error('登录过程中发生错误')
      } finally {
        this.loading = false
      }
    },
    handleClose () {
      this.$store.commit('setShowLogin', false)
    }
  }
}
</script>

<style scoped>
:deep(.el-dialog__header){padding:0;}
:deep(.el-dialog__body){padding:0;}
.login-form :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: #198052;
  border-color: #198052;
}
.login-form :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #198052;
}
.login-page{position:relative;}
.login-img{display: block;}
.login-form{position:absolute;top:50%;right:58px;transform: translate(0, -50%);background-color:#fff;width:364px;border-radius:4px;padding:20px 25px;box-shadow:0 0 10px rgba(0,0,0,.1);}
.login-logo{display: block;margin:0 auto 16px;}
.login-btn{width:100%;background-color:#198052;border-color:#198052;}
</style>